import type { ContentPage } from "@/lib/content/types";

// CRM › Sales Enablement › Calendar (leaf).
export const calendar: ContentPage = {
  slug: "sales-enablement/calendar",
  template: "hrmsFeature",
  seo: {
    title: "CRM Calendar - Schedule & Sync Meetings | GetBiz CRM",
    description: "Schedule and sync meetings inside GetBiz CRM. Share booking links, sync your calendar and see every meeting alongside its deal and contact.",
    keywords: ["crm calendar", "sales scheduling", "meeting scheduling", "calendar sync crm"],
    ogImage: "/assets/data/seoimages/calendar.webp",
  },
  leaf: {
    hero: {
      caption: "Calendar",
      title: "Manage Every Meeting From the CRM",
      description: "Sync calendars, share booking links and see all your meetings next to the deals and contacts they belong to.",
      h1: "caption",
    },
    split: {
      title: "Why Teams Choose Calendar",
      bullets: [
        { title: "Two-Way Sync", description: "Keep the CRM and your calendar in step." },
        { title: "Booking Links", description: "Let prospects self-schedule in open slots." },
        { title: "In-Context", description: "See meetings next to the related deal." },
        { title: "Reminders", description: "Automatic reminders cut no-shows." },
      ],
      image: "/assets/images/img/product/crm/calendar-lead-image.webp",
      imageAlt: "Calendar — GetBiz CRM",
    },
    cardsHeading: {
      title: "Works With the Rest of Sales Enablement",
      description: "Calendar connects to every other part of Sales Enablement in GetBiz CRM.",
    },
    cards: [
      { title: "Finance", href: "/crm-software/sales-enablement/finance/", description: "Manage quotes, invoices and payments alongside deals so revenue moves from closed-won to collected without gaps.", image: "/assets/images/img/product/crm/finance.webp", imageAlt: "GetBiz CRM finance" },
      { title: "Configure, Price, Quote (CPQ)", href: "/crm-software/sales-enablement/configure-price-quote/", description: "Configure products, apply the right pricing and generate professional quotes instantly.", image: "/assets/images/img/product/crm/configure-price-quote.webp", imageAlt: "GetBiz CRM configure, price, quote (cpq)" },
      { title: "Documents Library", href: "/crm-software/sales-enablement/documents-library/", description: "Store, share and track proposals, decks and contracts from a central library, right where your deals live.", image: "/assets/images/img/product/crm/documents-library.webp", imageAlt: "GetBiz CRM documents library" },
      { title: "SalesInbox", href: "/crm-software/sales-enablement/salesinbox/", description: "Work email inside the CRM with full deal context beside every message.", image: "/assets/images/img/product/crm/salesInbox.webp", imageAlt: "GetBiz CRM salesinbox" },
    ],
    testimonials: {
      title: "Businesses across India love & trust GetBiz!",
      description: "See why teams choose GetBiz CRM to run their sales.",
    },
    bookDemoTitle: "See Calendar in action.",
    relatedBlogs: "static",
    metaKey: "sales-enablement-calendar",
  },
  sections: [],
};
